import { graphql } from 'gatsby';
import { Callout, CalloutTitle, CalloutText } from "../../../../src/components/callout";
import { Anchor } from '@twilio-paste/anchor';
import * as React from 'react';
export default {
  graphql,
  Callout,
  CalloutTitle,
  CalloutText,
  Anchor,
  React
};